<div id="invitacion"></div>
<app-admin-dashboard>
  <div class="card">
    <p-breadcrumb
      class="w-full breadcrumb-style"
      [home]="breadcrumbHome"/>

    <div class="header-card pt-0">
      <div class="w-12 container-title">
        <h1 class="text-xl font-medium text-800 m-0">
          {{'InvitationCodePage.PageTitle' | translate}}
        </h1>
      </div>
    </div>

    <div class="body-card mt-3">
      <form [formGroup]="formGroup">
        <div class="flex flex-wrap flex-column justify-content-center align-items-center">
          <div class="w-full md:w-5 p-fluid formgrid grid">
            <div class="field col-12 xl:col-6">
              <label for="language">
                {{'InvitationCodePage.LanguageFieldLabel' | translate }}
                <span class="mandatory-field">*</span>
              </label>
              <p-dropdown
                [options]="langs"
                inputId="language"
                optionLabel="label"
                optionValue="lang"
                formControlName="language"
                (onChange)="switchLang()"
                [showClear]="false"
                [autoDisplayFirst]="false"
                placeholder="{{ 'InvitationCodePage.LanguageFieldPlaceholder' | translate}}"
                class="custom-dropdown">
                <ng-template pTemplate="selectedItem">
                  <div class="flex align-items-center">
                    <img [flag]="lang.icon" style="width: 18px" alt="" *ngIf="lang"/>
                    <span>&nbsp;{{lang?.label}}</span>
                  </div>
                </ng-template>
                <ng-template let-lang pTemplate="item">
                  <div class="flex align-items-center">
                    <img [flag]="lang.icon" style="width: 18px" alt=""/>
                    <span>&nbsp;{{lang.label}}</span>
                  </div>
                </ng-template>
              </p-dropdown>
              <small *ngIf="submit && formGroup.controls['language'].invalid" class="p-error">{{getErrorMessage('language')}}</small>
            </div>

            <div class="field col-12 xl:col-6">
              <label for="fullname">
                {{'InvitationCodePage.FullNameLabel' | translate }}
                <span class="mandatory-field">*</span>
              </label>
              <input
                id="fullname"
                formControlName="fullname"
                type="text"
                maxlength="120"
                required
                pInputText
                placeholder="{{'InvitationCodePage.FullNameFieldPlaceholder' | translate }}"
                [(ngModel)]="fullname"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['fullname'].invalid" class="p-error">{{getErrorMessage('fullname')}}</small>
            </div>

            <div class="field col-12 md:col-6" style="margin-bottom: 20px;">
              <label for="email">
                {{'InvitationCodePage.EmailFieldLabel' | translate }}
                <span class="mandatory-field">*</span>
              </label>
              <input
                id="email"
                formControlName="email"
                type="text"
                maxlength="50"
                required
                pInputText
                placeholder="{{'InvitationCodePage.EmailFieldPlaceholder' | translate }}"
                [(ngModel)]="email"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['email'].invalid" class="p-error">{{getErrorMessage('email')}}</small>
            </div>

            <div class="field col-12" style="margin-bottom: 20px;">
              <div class="w-full">
                <p-button
                  (onClick)="generateCode()"
                  [loading]="loading"
                  label="{{'InvitationCodePage.GenerateCode' | translate}}"
                  styleClass="p-button-primary"
                  class="custom-text-button"/>
              </div>
            </div>
          </div>

        </div>
      </form>

      <h3 class="text-lg font-medium text-800 mt-5">
        {{'InvitationCodePage.RequestedCodesSubtitle' | translate}}
      </h3>
      <div class="px-5">
        <p-table id="solicitudes" *ngIf="requestCodes.length > 0"
          [value]="requestCodes"
          [rowsPerPageOptions]="[10, 25, 50]"
          [rows]="10"
          [paginator]="true"
          [loading]="loading"
          [globalFilterFields]="['id', 'code', 'email']"
          class="custom-table bg-header">
          <ng-template pTemplate="header">
            <tr>
              <th>
                <div class="flex justify-content-center align-items-center">
                  {{'InvitationCodePage.Table.Id' | translate}}
                  <p-columnFilter type="text" field="id" display="menu" [showAddButton]="false" [showMatchModes]="false" [showOperator]="false"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="flex align-items-center">
                  {{'InvitationCodePage.Table.Language' | translate}}
                </div>
              </th>
              <th>
                <div class="flex align-items-center">
                  {{'InvitationCodePage.Table.Fullname' | translate}}
                </div>
              </th>
              <th>
                <div class="flex align-items-center">
                  {{'InvitationCodePage.Table.Email' | translate}}
                  <p-columnFilter type="text" field="email" display="menu" [showAddButton]="false" [showMatchModes]="false" [showOperator]="false" matchMode="contains"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="flex justify-content-center align-items-center">
                  {{'InvitationCodePage.Table.RequestDate' | translate}}
                  <p-columnFilter type="date" field="created" display="menu" [showAddButton]="false" [showMatchModes]="false" [showOperator]="false" matchMode="filter-date"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="flex justify-content-center align-items-center">
                  {{'InvitationCodePage.Table.Actions' | translate}}
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-request>
            <tr>
              <td>
                <div class="flex justify-content-center align-items-center">
                  <span>{{request.id}}</span>
                </div>
              </td>
              <td>
                <div class="flex align-items-center">
                    <img [flag]="(request.language === 'es' ? 'ES.png' : 'GB.png')" style="width: 18px" alt=""/>
                    <span>&nbsp;{{showLanguage(request.language)}}</span>
                </div>
              </td>
              <td>
                <div class="flex align-items-center">
                  <span>{{request.fullname}}</span>
                </div>
              </td>
              <td>
                <div class="flex align-items-center">
                  <span>{{request.email}}</span>
                </div>
              </td>
              <td>
                <div class="flex justify-content-center align-items-center">
                  <span>{{request.created | date: 'dd-MM-yyyy HH:mm'}}</span>
                </div>
              </td>
              <td>
                <div class="flex justify-content-center align-items-center">
                  <p-button
                    label="{{'InvitationCodePage.GenerateButton' | translate}}"
                    (onClick)="createCode(request)"
                    styleClass="p-button-primary"
                    class="custom-text-button"
                    icon="pi pi-check-circle"></p-button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <h3 class="text-lg font-medium text-800 mt-5">
        {{'InvitationCodePage.GeneratedCodesSubtitle' | translate}}
      </h3>
      <div class="px-5">
        <p-table
          [value]="invitationCodes"
          [rowsPerPageOptions]="[10, 25, 50]"
          [rows]="10"
          [paginator]="true"
          [loading]="loading"
          [globalFilterFields]="['id', 'code', 'email']"
          class="custom-table bg-header">
          <ng-template pTemplate="header">
            <tr>
              <th>
                <div class="flex justify-content-center align-items-center">
                  {{'InvitationCodePage.Table.Id' | translate}}
                  <p-columnFilter type="text" field="id" display="menu" [showAddButton]="false" [showMatchModes]="false" [showOperator]="false"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="flex align-items-center">
                  {{'InvitationCodePage.Table.Language' | translate}}
                </div>
              </th>
              <th>
                <div class="flex align-items-center">
                  {{'InvitationCodePage.Table.Code' | translate}}
                </div>
              </th>
              <th>
                <div class="flex align-items-center">
                  {{'InvitationCodePage.Table.Fullname' | translate}}
                </div>
              </th>
              <th>
                <div class="flex align-items-center">
                  {{'InvitationCodePage.Table.Email' | translate}}
                  <p-columnFilter type="text" field="email" display="menu" [showAddButton]="false" [showMatchModes]="false" [showOperator]="false" matchMode="contains"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="flex justify-content-center align-items-center">
                  {{'InvitationCodePage.Table.RequestDate' | translate}}
                  <p-columnFilter type="date" field="created" display="menu" [showAddButton]="false" [showMatchModes]="false" [showOperator]="false" matchMode="filter-date"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="flex justify-content-center align-items-center">
                  {{'InvitationCodePage.Table.Actions' | translate}}
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-code>
            <tr>
              <td>
                <div class="flex justify-content-center align-items-center">
                  <span>{{code.id}}</span>
                </div>
              </td>
              <td>
                <div class="flex align-items-center">
                    <img [flag]="(code.language === 'es' ? 'ES.png' : 'GB.png')" style="width: 18px" alt=""/>
                    <span>&nbsp;{{showLanguage(code.language)}}</span>
                </div>
              </td>
              <td>
                <div class="flex align-items-center">
                    <span>{{code.code}}</span>
                </div>
              </td>
              <td>
                <div class="flex align-items-center">
                  <span>{{code.fullname}}</span>
                </div>
              </td>
              <td>
                <div class="flex align-items-center">
                  <span>{{code.email}}</span>
                </div>
              </td>
              <td>
                <div class="flex justify-content-center align-items-center">
                  <span>{{code.created | date: 'dd-MM-yyyy HH:mm'}}</span>
                </div>
              </td>
              <td>
                <div class="flex justify-content-center align-items-center">
                  <p-button
                    label="{{'InvitationCodePage.InactivateButton' | translate}}"
                    (onClick)="inactiveCode(code.id)"
                    styleClass="p-button-danger"
                    class="custom-text-button danger-filled"
                    icon="pi pi-minus-circle"></p-button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

  </div>
</app-admin-dashboard>


<p-confirmDialog acceptLabel="Si" rejectLabel="No" rejectButtonStyleClass="p-button-outlined" [style]="{width: '50vw'}"></p-confirmDialog>
